import React, { useEffect } from 'react';
import {
    CombosItemContainer,
    CombosItemContent,
    CombosItemFavorite,
    CombosItemSeeCoupon,
    CombosItemTop,
    CombosItemTopLeft,
    CombosItemWrapper,
} from './styled';
import Text from '../../../ui/Text';
import Icon from '../../../ecoui/Icon';
import Arrow from './../../../images/arrow.svg';
import { getComboItems } from '../helper';
import { showModal as ShowModal } from '../../../actions/UiActions';
import { connect } from 'react-redux';
import { SYSTEM_NAMES_WEB } from '../../../constants/appConfig';
import CombosButton from '../ComboButton/ComboButton';

const CombosItem = ({
    markets,
    showModal,
    betslip,
    firstItem,
    position,
    userId,
}) => {
    return (
        <CombosItemWrapper>
            <CombosItemContent
                onClick={() =>
                    showModal('COMBO_DESCRIPTION_MODAL', {
                        markets,
                        position,
                        userId,
                        hasMarkets: betslip.hasMarkets,
                    })
                }
            >
                <CombosItemTop>
                    <CombosItemTopLeft>
                        <Text
                            width={'auto'}
                            margin={'0'}
                            padding={'0'}
                            size={'13'}
                            lh={'20'}
                            flex={'0'}
                            bold
                            color={'#1e1e1e'}
                        >
                            {SYSTEM_NAMES_WEB[markets.betItems.length - 1]}
                        </Text>
                        {firstItem && (
                            <CombosItemFavorite>
                                Spillerfavorit
                            </CombosItemFavorite>
                        )}
                    </CombosItemTopLeft>
                    <CombosItemSeeCoupon>
                        Se kupon{' '}
                        <Icon
                            size={'xxs'}
                            margin={'0 0 0 8px'}
                            src={Arrow}
                            color={'#4F555E'}
                        />
                    </CombosItemSeeCoupon>
                </CombosItemTop>
                <CombosItemContainer
                    className={`${markets.betItems.length > 3 ? 'long' : ''}`}
                >
                    {getComboItems(markets, false, betslip.setMarketsNew)}
                </CombosItemContainer>
            </CombosItemContent>

            <CombosButton
                position={position}
                userId={userId}
                markets={markets}
            />
        </CombosItemWrapper>
    );
};

function mapStateToProps(state) {
    return { auth: state.auth, betslip: state.betslip };
}

const mapDispatchToProps = (dispatch) => {
    return {
        showModal: (modalId, data) => dispatch(ShowModal(modalId, data)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CombosItem);
